<template>
  <div class="relative">
    <div v-if="!isMobile && resultBadges.length < 10" class="flex space-x-4 mr-1.5">
      <a
        v-for="(budge, i) in resultBadges"
        :key="i"
        class="outline-none w-6 h-6"
        :href="budge.href"
        :title="budge.title"
        :rel="budge.flags.nofollow ? 'nofollow' : undefined"
        @click="$analyticsEvent('Menu', 'Badge_Click', `badge_${budge.title.toLowerCase()}`)"
      >
        <img :src="budge.image" :alt="budge.title" class="w-6 h-6" width="24px" height="24px" />
      </a>
    </div>
    <div v-else class="sm:w-[433px] w-full">
      <span ref="prevNavBtn" class="absolute left-0 top-1/2 -translate-y-1/2 h-full u-center cursor-pointer" pure>
        <OIcon :icon="isMobile ? 'left-dark' : 'left-white'" />
      </span>
      <Swiper :settings="settings" style="height: 38px" class="swiper-badge" :modules="[Autoplay, Navigation]" @swiper="onSwiper">
        <SwiperSlide
          v-for="(budge, i) in resultBadges"
          :key="i"
          element="a"
          :class="isMobile ? 'py-0.5 px-0.5' : 'py-2'"
          class="outline-none u-center"
          :href="budge.href"
          :title="budge.title"
          :rel="budge.flags.nofollow ? 'nofollow' : undefined"
        >
          <img v-if="isMobile" :src="budge.image" :alt="budge.title" class="w-8 h-8" width="32px" height="32px" loading="lazy" />
          <img v-else :src="budge.image" :alt="budge.title" class="'w-6 h-6" width="24px" height="24px" loading="lazy" />
        </SwiperSlide>
      </Swiper>
      <span ref="nextNavBtn" class="absolute right-0 top-1/2 -translate-y-1/2 h-full u-center cursor-pointer" pure>
        <OIcon :icon="isMobile ? 'right-dark' : 'right-white'" />
      </span>
    </div>
  </div>
</template>
<script>
import { defineComponent, computed, ref, useContext } from '@nuxtjs/composition-api';
import { Navigation, Autoplay } from 'swiper';
import Swiper from '@/modules/sliders/core/Swiper';
import SwiperSlide from '@/modules/sliders/core/SwiperSlide';
import { useDevice } from '~/composables/useDevice';
import { useMetadataConfig } from '~/modules/config/configUtils';
import { OIcon } from '~/modules/common/components/ui';

export default defineComponent({
  props: {},
  components: {
    Swiper,
    SwiperSlide,
    OIcon,
  },
  setup() {
    const { badges } = useMetadataConfig();
    const { $analyticsEvent } = useContext();
    const prevNavBtn = ref(null);
    const nextNavBtn = ref(null);
    const { isMobile } = useDevice();
    const slidesPerView = isMobile.value ? 6 : 10;
    const resultBadges = computed(() =>
      isMobile.value
        ? badges
            .filter((badge) => badge.showAt.mobile)
            .map((badge) => ({
              ...badge,
              image: badge?.image?.mobile || badge?.image?.desktop || '',
            })) || []
        : badges
            .filter((badge) => badge.showAt.desktop)
            .map((badge) => ({
              ...badge,
              image: badge?.image?.desktop || badge?.image?.mobile || '',
            })) || []
    );

    const settings = {
      slidesPerView,
      speed: 300,
      loop: true,
      preloadImages: false,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: nextNavBtn,
        prevEl: prevNavBtn,
      },
    };

    const onSwiper = (swiper) => {
      swiper.on('click', (swiper) => {
        const slideIndex = parseInt(swiper.clickedSlide.dataset.swiperSlideIndex);
        $analyticsEvent('Menu', 'Badge_Click', `badge_${resultBadges.value[slideIndex].title.toLowerCase()}`);
      });
    };

    return {
      settings,
      isMobile,
      Autoplay,
      Navigation,
      prevNavBtn,
      nextNavBtn,
      onSwiper,
      resultBadges,
    };
  },
});
</script>

<style lang="scss" scoped>
.swiper-badge {
  margin-left: 20px !important;
  margin-right: 20px !important;
}
</style>
